import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    paddingVertical: 53,
  },
  columnContainer: {
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    gap: 20,
  },
  leftColumn: {
    flex: 0.5,
    paddingBottom: 30,
    paddingLeft: 53,
    gap: 20,
  },
  middleColumn: {
    flex: 1,
    paddingBottom: 30,
  },
  rightColumn: {
    flex: 1,
    paddingBottom: 30,
    paddingRight: 53,
  },

  middleColumnRow1: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
  },

  textWrapper: {
    borderRadius: '5px',
    border: '2px solid white',
    color: 'white',
    paddingTop: 5,
    paddingBottom: 15,
    paddingHorizontal: 10,
    width: '100%',
    height: 'auto',
  },
  title: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 900,
    lineHeight: 1.2,
    paddingBottom: 20,
    marginBottom: 10,
    width: '100%',
  },
  subtitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.2,
  },

  rightColumnWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    width: '100%',
  },
  columnWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '100%',
  },

  leftBigImage: {
    width: '100%',
    height: '350px',
    objectFit: 'cover',
    borderRadius: '5px',
  },
  leftSmallImage: {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
    borderRadius: '5px',
  },
  middleColumnBigImage: {
    width: '100%',
    height: '280px',
    objectFit: 'cover',
    borderRadius: '5px',
    marginTop: 20,
    marginBottom: 20,
  },
  rightColumnLeftImage: {
    width: '100%',
    height: '320px',
    objectFit: 'cover',
    borderRadius: '5px',
  },
  rightColumnRightImage: {
    width: '100%',
    height: '510px',
    objectFit: 'cover',
    borderRadius: '5px',
  },
});
